/* istanbul ignore file - better tested visually */
import { DataGrid as MuiDataGrid, DataGridProps as MUIDataGridProps } from '@mui/x-data-grid';
import { classNames } from '@partful/shared/lib/classNames';
import styles from './DataGrid.module.scss';

export default function DataGrid({ className, ...props }: MUIDataGridProps) {
  return <MuiDataGrid className={classNames(styles.base, className)} {...props} />;
}
